define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var CPComposeNotificationModel = /** @class */ (function () {
        function CPComposeNotificationModel(data) {
            this.NotificationKey = ko.observable('whatsnew');
            this.NotificationType = ko.observable('dialog');
            this.Text = ko.observable();
            this.Title = ko.observable();
            this.ButtonTitle = ko.observable('Got It');
            this.HideCancel = ko.observable(true);
            this.CustomerTypeSet = ko.observable('all');
            this.DialogWidth = ko.observable('50%');
            this.Modules = ko.observableArray([]);
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, CPComposeNotificationModel.Mapping, self);
            }
        }
        CPComposeNotificationModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new CPComposeNotificationModel(options.data);
            },
        };
        return CPComposeNotificationModel;
    }());
    return CPComposeNotificationModel;
});
//# sourceMappingURL=CPComposeNotificationModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/CPComposeNotificationModel.js
// module id = 308
// module chunks = 2